<template>
	<div :class="containerClasses">
		<div class="approval-ratings-left-wrapper">
			<h1>{{ t("approval_ratings.global_title") }}</h1>
		</div>
		<div class="range-slider-wrapper">
			<div class="range-slider-wrapper-label-left">{{ min }}</div>
			<div class="range-slider-wrapper-interactive">
				<range-slider
					v-if="canEdit"
					v-on:approval-ratings-changed="handleIncoming"
					:actor-approval-rating="ownedApprovalRating.rating"
				></range-slider>
				<percent-from-center-bar
					:value="averageApprovalRating"
					:min="min"
					:max="max"
				></percent-from-center-bar>
			</div>
			<div class="range-slider-wrapper-label-right">{{ max }}</div>
		</div>
		<div class="approval-ratings-right-wrapper">
			<div
				v-if="canEdit"
				class="approval-ratings-number-box approval-ratings-number-box-own-rating"
			>
				<span>{{ t("approval_ratings.own_value") }}</span>
				<rainbow-range-value-box
					:min="min"
					:max="max"
					:value="ownedApprovalRating.rating"
				></rainbow-range-value-box>
			</div>
			<div
				class="approval-ratings-number-box approval-ratings-number-box-avg-rating"
			>
				<span>{{ t("approval_ratings.average_value") }}</span>
				<rainbow-range-value-box
					:min="min"
					:max="max"
					:value="averageApprovalRating"
				></rainbow-range-value-box>
			</div>
		</div>
	</div>
</template>

<script>
import { findInCollectionOr, i18n } from "../utils";
// Other components
import PercentFromCenterBar from "./graphs_and_visualizations/percent_from_center_bar.vue";
import RangeSlider from "./range_slider.vue";

export default {
	mixins: [i18n],
	props: {
		srvApprovalRatings: Array,
		min: Number,
		max: Number,
		canEdit: Boolean,
		approvalColors: {
			type: Array,
			default: function () {
				return [
					"#BB0000",
					"#BB2900",
					"#BB5300",
					"#BB7C00",
					"#BBA600",
					"#A6BB00",
					"#7CBB00",
					"#53BB00",
					"#29BB00",
					"#00BB00",
				];
			},
		},
	},
	components: {
		"range-slider": RangeSlider,
		"percent-from-center-bar": PercentFromCenterBar,
	},
	data: function () {
		return { approval_ratings: this.srvApprovalRatings };
	},
	computed: {
		postUrl() {
			return `/actors/${pp.currentActorId}/approval_ratings`;
		},
		ownedApprovalRating() {
			return findInCollectionOr(
				// @ts-expect-error
				this.approval_ratings,
				"actor",
				pp.currentActorId,
				function () {
					return { actor_id: pp.currentActorId, rating: 0 };
				},
			);
		},
		averageApprovalRating() {
			// @ts-expect-error
			if (this.approval_ratings.length === 0) {
				return 0;
			}
			var sum = _.reduce(
				_.clone(this.approval_ratings),
				function (sum, ar) {
					return ar.rating + sum;
				},
				0,
			);
			// @ts-expect-error
			return Math.round((sum / this.approval_ratings.length) * 10) / 10;
		},
		containerClasses() {
			var classnames = "approval-ratings-container";
			if (this.canEdit) {
				classnames += " approval-ratings-container-can-edit";
			}
			return classnames;
		},
	},
	mounted() {
		pp.vue.bus.$on("approval_rating-CREATE", (ar) => {
			this.handleIncoming(ar);
		});
		pp.vue.bus.$on("approval_rating-CREATE", (value) => {
			// optimistic updates, and make sure the average is set
			pp.vue.bus.$emit("approval_rating-CREATE", {
				actor_id: pp.currentActorId,
				rating: value,
			});
			$.post(
				this.postUrl + ".json",
				{
					approval_rating: { actor_id: pp.currentActorId, rating: value },
					average_at_creation: this.averageApprovalRating,
				},
				(res) => {
					pp.vue.bus.$emit("approval_rating-CREATE", res);
				},
			);
		});
	},
	beforeDestroy() {
		pp.vue.bus.$off("approval_rating-CREATE");
	},
	methods: {
		handleIncoming(payload) {
			// pp.log(_.map(this.approval_ratings, function(ar){ return ""+ar.actor_id+":"+ar.rating }));
			var idx = _.findIndex(this.approval_ratings, (ar) => {
				return ar.actor_id === payload.actor_id;
			});
			// Replace the approval_rating property for the actor, or create one if they haven't
			if (idx !== -1) {
				// @ts-expect-error
				this.approval_ratings[idx].rating = payload.rating;
			} else {
				// @ts-expect-error
				this.approval_ratings.push(payload);
			}
		},
	},
};
</script>
